import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <AboutSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <TopicsSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}